import React, { useState } from "react";
import {
  markSubCategoryFeatured,
  markSubCategoryUnFeatured,
} from "../../../services/subCategoryService";
import Swal from "sweetalert2";
import { handleErrors } from "../../../utils/errorHandler";

const SubCategoryFeaturedToggleSwitch = ({
  propId,
  initialStatus,
  onStatusChange,
}) => {
  const [isFeatured, setisFeatured] = useState(initialStatus === "Featured");

  const handleToggle = async () => {
    const newStatus = isFeatured ? "UnFeatured" : "Featured";
    const modalTitle = isFeatured
      ? "Mark Sub-Category UnFeatured"
      : "Mark Sub-Category Featured";
    const modalMessage = isFeatured
      ? "Are you sure you want to mark this sub-category unfeatured?"
      : "Are you sure you want to mark this sub-category featured?";

    const result = await Swal.fire({
      title: modalTitle,
      text: modalMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        if (isFeatured) {
          await markSubCategoryUnFeatured(propId, newStatus);
        } else {
          await markSubCategoryFeatured(propId, newStatus);
        }
        setisFeatured(!isFeatured);
        onStatusChange(newStatus);

        Swal.fire(
          "Success!",
          `The sub-category has been ${
            newStatus === "Featured" ? "Featured" : "UnFeatured"
          }.`,
          "success"
        );
      } catch (error) {
        handleErrors(error);
      }
    }
  };

  return (
    <label className="switch">
      <div className="form-check form-switch form-switch-custom form-switch-primary">
        <input
          className="form-check-input"
          type="checkbox"
          checked={isFeatured} // Checked means user is Blocked
          onChange={handleToggle}
        />
      </div>
      <span className="slider round"></span>
    </label>
  );
};

export default SubCategoryFeaturedToggleSwitch;
